<template>
    <div>
        <div class="mask-image">
            <img src="../assets/mask.png">
        </div>
<!--        <div class="mask-cumulative-number">-->
<!--            <van-row>-->
<!--                <van-col span="12">-->
<!--                    <div>-->
<!--                        <div>-->
<!--                            <span>累计送出</span>-->
<!--                            <span>500</span>-->
<!--                            <span>个爱心</span>-->
<!--                        </div>-->
<!--                        <span>* 本次活动每人限参与一次，且由于参与人数较多请耐心等待客服联系</span>-->
<!--                    </div>-->
<!--                </van-col>-->
<!--                <van-col span="12">-->
<!--                    <img src="../assets/more-mask.png" style="width: 100%">-->
<!--                </van-col>-->
<!--            </van-row>-->
<!--        </div>-->
        <div class="my-apply">
            <div class="my-apply-num">我申请<span>{{maskNum}}</span>个口罩</div>
            <van-slider
                    v-model="maskNum"
                    bar-height="8px"
                    active-color="#ffd38d"
                    :min="0"
                    :max="5"
                    :step="1"
                    @change="onChange"
            >
                <template #button>
                    <div class="custom-button">
                        I I I
                    </div>
                </template>
            </van-slider>
            <div class="mask-num">
                <span class="mask-num-left">0</span>
                <span class="mask-num-right">5</span>
            </div>
            <div class="mask-for-hint">
                * 每人最多可以申请五个，请把需求分给更多的人
            </div>
        </div>
        <div class="get-mask-form">
                <van-form @submit="onSubmit">
                    <van-cell-group>
                        <van-field
                                v-model="username"
                                name="username"
                                label="我的名字:"
                                placeholder="姓名或昵称"
                                :rules="[{ required: true, message: ' ' }]"
                        />
                        <van-field
                                v-model="weixin"
                                name="weixin"
                                label="微信账号:"
                                placeholder="以方便客服联络"
                                :rules="[{ required: true, message: ' ' }]"
                        />
                        <van-field
                                v-model="phone"
                                name="phone"
                                label="我的电话:"
                                placeholder="请填写06或07开头的十位法国手机号"
                                :rules="[{ required: true, message: ' ' }]"
                        />
                        <van-field
                                v-model="email"
                                name="email"
                                label="我的邮箱:"
                                placeholder="以方便客服联络"
                                :rules="[{ required: true, message: ' ' }]"
                        />
                        <van-field
                                v-model="city"
                                name="city"
                                label="我的城市:"
                                placeholder="请输入所在城市的名称（法语）"
                                :rules="[{ required: true, message: ' ' }]"
                        />
                        <van-field
                                v-model="address"
                                name="address"
                                label="我的地址:"
                                placeholder="一分钱君送货上门"
                                :rules="[{ required: true, message: ' ' }]"
                        />
                        <van-field
                                v-model="postcode"
                                name="postcode"
                                label="区域邮编:"
                                placeholder="所在区域的邮编"
                                :rules="[{ required: true, message: ' ' }]"
                        />
                    </van-cell-group>
                    <div style="margin: 16px auto;width: 106px;padding:10px 0 25px">
                        <van-button round block type="info" native-type="submit">
                            提交申请
                        </van-button>
                    </div>
                </van-form>
        </div>
        <div class="for-mask-message">
            <div class="mask-message-title">爱心公益，若有疏忽，望多谅解</div>
            <div class="mask-message-list">
                <img src="../assets/mask-min-icon2.png" style="top: -16px">
                <span style="line-height: 20px">口罩数量有限，送完为止。<br>
                      为确保顺利送货，请仔细核对个人信息</span>
            </div>
            <div class="mask-message-list">
                <img src="../assets/mask-min-icon.png">
                <span>由于疫情限制，具体配送时间请等待客服确认</span>
            </div>
            <div class="mask-message-footer">
                <div class="hint-list">
                    <div class="hint-list-punctuation">*</div>
                    <div class="hint-list-text">
                        配送费由您自行承担：小巴黎地区送货上门，配送费5欧起，
                        其余地区邮寄，邮费7欧起
                    </div>
                </div>
                <div class="hint-list">
                    <div class="hint-list-punctuation">*</div>
                    <div class="hint-list-text">该活动最终解释权归一分钱所有</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { Toast } from 'vant';
    import Vue from 'vue';
    import { Slider } from 'vant';
    import {Cell,Field,Form,Popup,CellGroup} from 'vant';
    Vue.use(Form);
    Vue.use(Popup);
    Vue.use(Cell);
    Vue.use(Field);
    Vue.use(CellGroup);
    Vue.use(Slider);
    export default {
        data(){
            return {
                city:'',
                maskNum: 1,
                username:'',
                weixin:'',
                email:'',
                message:'',
                phone:'',
                area:'',
                address:'',
                postcode:'',
            }
        },
        beforeCreate(){
            if(this.$store.state.isApply == 1){
                this.$router.replace("/");
            }
        },
        methods:{
            onChange(value) {
                // Toast('当前值：' + value);
                this.maskNum = value;
            },
            onSubmit(values) {
                let data = {
                    'email': values.email,
                    'mobile': values.phone,
                    'needAddress': values.address,
                    'needCount': this.maskNum,
                    'realName': values.username,
                    'wechatId': values.weixin,
                    'zipCode': values.postcode,
                    'city':values.city
                };
                this.$axios.post('/api/service/mask/addInfo',data,{

                }).then(res => {
                    if(res.data.code){
                        Toast(res.data.data)
                    }else {
                        this.$store.commit('setMaskIsApply', 1);
                        this.$router.push("/mask-info");
                    }
                }).catch(error => {
                    console.log(error)
                })
            },
        },
        destroyed(){
            this.$store.commit('setUserMask', []);
        }
    }
</script>
<style>
    .order-info .van-field__label{
        width: 72px;
    }
    .mask-message-list span{
        width: 90%;display: inline-block;
    }
    .mask-image{
        font-size: 0;
    }
    .mask-cumulative-number{
        margin-top: 7px;background-color: #fff;
    }
    .mask-cumulative-number .van-row{
        width: 90%;margin: 0 auto;
    }
    .mask-cumulative-number .cumulative-box-left,.cumulative-box-right{
        display: inline-block;height: 100%;
    }
    .get-mask-form{
        background-color: #fff;padding: 0 29px;
    }
    .get-mask-form .van-cell{
        padding: 10px 0;border-bottom: 1px solid #e0e0e0;
    }
    .get-mask-form .van-button{
        background-color: #feda38;border: 0;color: #4a4a4a;
        height: 33px;
        line-height: 33px;}
    .get-mask-form .van-field__label{
        width: 70px;
    }
    .get-mask-form .van-cell span{
        color: #4a4a4a;font-size: 14px;
    }
    .for-mask-message{
        padding: 0 24px 40px;color: #4a4a4a;font-size: 14px;
    }
    .mask-message-list{
        font-size: 13px;color: #4a4a4a;margin-top: 12px;
    }
    .mask-message-list img{
        width: 16px;position: relative;top: 4px;margin-right: 7px;
    }
    .van-cell__title{
        text-align: left;
    }
    .my-address div{
        width: 98%;
    }
    .my-address i{
        line-height: 24px;
    }
    .van-nav-bar{
        background-color: yellow;
    }
    .mask-image img{
        width: 100%;
    }
    .my-apply{
        height: 150px;
        background-color: #fff;
        margin: 7px 0 7px 0;
    }
    .my-apply .van-slider{
        top: 20%;
        margin: 0 auto;
        width: 90%;
    }
    .custom-button {
        width: 40px;
        color: #fff;
        font-size: 10px;
        line-height: 18px;
        text-align: center;
        background-color: #f9b240;
        border-radius: 15px;
    }
    .my-apply-num{
        text-align: center;
        font-size: 14px;
        position: relative;
        top: 10%;
        color: #4a4a4a;
        padding-top:7px;
    }
    .my-apply-num span{
        color: #f9b13e;
        margin: 0 5px;
        font-size: 17px;
    }
    .van-slider{
        height: 8px;
    }
    .mask-num{
        top: 30%;
        position: relative;
        width: 90%;
        margin: 0 auto;
        color: #8f8e8b;
        font-size: 13px;
    }
    .mask-num-left{
        float: left;
    }
    .mask-num-right{
        float: right;
    }
    .mask-for-hint{
        text-align: center;
        position: relative;
        top: 50%;
        font-size: 8px;
        color: #4a4a4a;
    }
    .mask-message-footer{
        margin-top: 20px;
        border-top: 1px solid #e0e0e0;
        padding-top: 7px;
        font-size: 12px;
        color: #9b9b9b;
    }
    .hint-list-punctuation{
        display: inline-block;
        float: left;
        position: relative;
        top: 4px;
    }
    .hint-list-text{
        width: 90%;
        display: inline-block;
        padding-left: 10px;
    }
    .hint-list{
        margin-bottom: 10px;
    }
</style>